import React from 'react';
import emptyImg from '@/assets/images/empty.webp';

interface Props {
  image?: string;
  label?: string;
  description?: string;
}

export const EmptyState: React.FC<Props> = ({
  image = emptyImg,
  label,
  description,
}) => (
  <div className="flex flex-1 flex-col items-center justify-center gap-1 px-4 text-center">
    <img
      src={image}
      alt=""
      width={120}
      height={120}
      className="size-[82px] md:size-[120px]"
    />
    <div className="flex flex-col items-center gap-0.5 md:gap-1">
      {label && (
        <p className="text-callout-16 text-subtle-foreground md:text-body-16">
          {label}
        </p>
      )}
      {description && (
        <p className="text-body-13 max-w-[316px] text-subtle-foreground md:text-body-14">
          {description}
        </p>
      )}
    </div>
  </div>
);
